export interface IPage {
  title: string;
  titleKey: string;
  icon: string;
  relatedModule?: string;
}

export interface ITableHeader {
  value: string;
  name: string;
  type?: PageConfigurationTypes;
  class?: string;
  width?: string;
  disabled?: boolean;
  selected?: boolean;
  sortable?: boolean;
  linkedTo?: string;
}

export enum PageConfigurationTypes {
  WIDGET = 'widget',
  TABLE = 'table',
}

export enum PageRefreshIntervals {
  work_orders = 120,
  production_review = 60,
  line_view_extended = 60,
  asset_view = 60,
}
